/* Authenticated Account Centre sub-screens. The browser only reads/writes the
   signed-in user's owner-protected Supabase rows. */

(function () {
  var SESSION_KEY = 'gettmi:session:v1';
  var defaults = {
    order_updates: true,
    saved_item_alerts: true,
    brand_alerts: true,
    daily_edit: false,
    style_account_nudges: true,
    security_alerts: true
  };
  var addressState = {
    addresses: [],
    role: '',
    editing: false,
    activeAddress: null,
    isDefault: false,
    isBilling: false
  };
  var orderState = {
    activeOrder: null,
    activeTab: 'orders',
    loaded: false,
    loading: false,
    orders: [],
    query: ''
  };
  var informationState = {
    consentMetadata: {},
    consents: {},
    girlMathsConsentVersion: '',
    girlMathsPhotosOn: null,
    profile: {}
  };
  var securityState = {
    accountChoice: 'deactivate',
    currentDevice: null,
    settings: {},
    trustedDevices: []
  };
  var returnReasons = [
    { code: 'too_small', group: 'Fit', hint: 'The fit came up smaller than expected.', label: 'Too small' },
    { code: 'too_big', group: 'Fit', hint: 'The fit came up larger than expected.', label: 'Too big' },
    { code: 'doesnt_suit_me', group: 'Style', hint: 'The shape, colour, or vibe is not right for you.', label: 'Doesn’t suit me' },
    { code: 'doesnt_match_description', group: 'Product', hint: 'It looks or feels different from the photos or description.', label: 'Doesn’t match the photos or description' },
    { code: 'quality_issue', group: 'Product', hint: 'There is a fabric, finish, or construction issue.', label: 'Quality issue' },
    { code: 'arrived_damaged', group: 'Delivery', hint: 'It arrived marked, damaged, or not as expected.', label: 'Arrived damaged' },
    { code: 'wrong_item', group: 'Delivery', hint: 'The item received is not what you ordered.', label: 'Wrong item received' },
    { code: 'changed_mind', group: 'Preference', hint: 'You no longer want to keep this piece.', label: 'Changed my mind' },
    { code: 'other', group: 'Other', hint: 'Something else is going on.', label: 'Other' }
  ];
  var returnState = {
    error: '',
    idempotencyKey: '',
    note: '',
    order: null,
    reasonCode: '',
    selectedItemIds: {},
    submitted: null,
    submitting: false
  };
  var aboutPages = {
    'about-us': {
      title: 'About Us',
      heroTitle: 'About Gettmi',
      heroSubtitle: 'Fashion discovery, made sharper.',
      intro: [
        'Gettmi is a fashion platform built around discovery. We bring together standout brands, influencer-led labels, and pieces people are already searching for, saving, and wearing.',
        'The aim is simple: make it easier to find what feels current, considered, and worth adding to your wardrobe.'
      ],
      pills: ['Curated edits', 'Creator-led brands', 'Global style'],
      sections: [
        {
          title: 'OUR POINT OF VIEW',
          paragraphs: [
            'Fashion moves quickly, but shopping should still feel intentional. Gettmi edits the noise into a more focused experience, from event dresses and holiday pieces to everyday wardrobe updates.',
            'Every collection is shaped by what is happening across style, culture, creators, and the brands gaining real attention.'
          ]
        },
        {
          title: 'GLOBAL STYLE',
          tone: 'alt',
          paragraphs: [
            'We source across established names, cult favourites, emerging designers, and influencer-founded brands.',
            'From London to LA and beyond, Gettmi is designed to help you discover labels with a clear point of view, not just another endless product grid.'
          ]
        },
        {
          title: 'SHOPPING WITH CONTEXT',
          paragraphs: [
            'We want shopping to feel more useful, more visual, and more personal. That means curated edits, smarter discovery tools, style-led recommendations, and a platform that helps you understand why something belongs in your wardrobe.'
          ]
        }
      ],
      bannerImage: 'https://cdn.shopify.com/s/files/1/0940/4245/6394/files/about-gettmi-banner_78b7bf6e-1d8e-480c-b024-83d46cd83993.png?v=1760222008'
    },
    'social-impact': {
      title: 'Social Impact',
      heroTitle: 'SOCIAL IMPACT',
      heroSubtitle: 'Style with a wider responsibility.',
      intro: [
        'Gettmi is being built with the belief that fashion discovery should support creativity, opportunity, and more responsible choices.',
        'As we grow, our social impact work will focus on the communities, creators, brands, and partners connected to the platform.'
      ],
      pills: ['Community', 'Opportunity', 'Responsible growth'],
      sections: [
        {
          title: 'OUR APPROACH',
          paragraphs: [
            'We want Gettmi to create value beyond the transaction by spotlighting emerging brands, supporting founder-led businesses, and helping customers discover labels with real identity.',
            'Our platform is designed to make smaller and independent voices easier to find alongside more established names.'
          ]
        },
        {
          title: 'CREATORS AND COMMUNITY',
          tone: 'alt',
          paragraphs: [
            'Creators shape how fashion is discovered. We want to build relationships that feel respectful, transparent, and commercially meaningful.',
            'As the community develops, this section will share the initiatives, partnerships, and opportunities connected to Gettmi’s wider impact.'
          ]
        },
        {
          title: 'WHAT COMES NEXT',
          paragraphs: [
            'Future updates may include partner spotlights, community programmes, charitable collaborations, and progress against responsible business goals.'
          ]
        }
      ]
    },
    ambassadors: {
      title: 'Ambassadors',
      heroTitle: 'AMBASSADORS',
      heroSubtitle: 'For the voices shaping what gets seen.',
      intro: [
        'The Gettmi ambassador community is for creators, stylists, tastemakers, and fashion voices who naturally influence what people discover, save, and wear.',
        'This will become the home for ambassador opportunities, creator partnerships, and ways to collaborate with Gettmi.'
      ],
      pills: ['Creators', 'Style voices', 'Partnerships'],
      sections: [
        {
          title: 'WHO IT IS FOR',
          paragraphs: [
            'We are interested in people with a clear fashion point of view, an engaged community, and a natural eye for the pieces that are about to matter.',
            'You do not need to fit one mould. We care about taste, trust, consistency, and the ability to make discovery feel personal.'
          ]
        },
        {
          title: 'HOW IT WORKS',
          tone: 'alt',
          paragraphs: [
            'Ambassador opportunities may include curated edits, brand campaigns, content partnerships, event moments, and early access to selected Gettmi features.',
            'As the programme develops, this page will include application details and current collaboration routes.'
          ]
        },
        {
          title: 'REGISTER INTEREST',
          paragraphs: [
            'For now, creators and partners interested in working with Gettmi should prepare their social links, location, audience details, and a short note on their style point of view.'
          ]
        }
      ]
    }
  };

  function resetOwnerState() {
    addressState.addresses = [];
    addressState.role = '';
    addressState.editing = false;
    addressState.activeAddress = null;
    addressState.isDefault = false;
    addressState.isBilling = false;
    orderState.activeOrder = null;
    orderState.activeTab = 'orders';
    orderState.loaded = false;
    orderState.loading = false;
    orderState.orders = [];
    orderState.query = '';
    informationState.consentMetadata = {};
    informationState.consents = {};
    informationState.girlMathsConsentVersion = '';
    informationState.girlMathsPhotosOn = null;
    informationState.profile = {};
    securityState.accountChoice = 'deactivate';
    securityState.currentDevice = null;
    securityState.settings = {};
    securityState.trustedDevices = [];
    returnState.error = '';
    returnState.idempotencyKey = '';
    returnState.note = '';
    returnState.order = null;
    returnState.reasonCode = '';
    returnState.selectedItemIds = {};
    returnState.submitted = null;
    returnState.submitting = false;

    var settings = root();
    if (!settings) return;
    settings.querySelectorAll('[data-gettmi-account-view]').forEach(function (accountView) {
      accountView.hidden = true;
    });
    applyNotificationState(defaults);
  }

  function root() {
    return document.querySelector('[data-gettmi-settings]');
  }

  function config() {
    var el = document.querySelector('[data-gettmi-supabase]');
    return el ? { url: el.dataset.supabaseUrl, key: el.dataset.supabaseKey } : null;
  }

  function appGateEnabled(surface) {
    return Boolean(
      window.GettmiAppGate &&
      typeof window.GettmiAppGate.isEnabled === 'function' &&
      window.GettmiAppGate.isEnabled(surface)
    );
  }

  function session() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeSession(nextSession) {
    try {
      window.localStorage.setItem(SESSION_KEY, JSON.stringify(nextSession));
    } catch (error) {
      /* The active page session can continue if storage is unavailable. */
    }
  }

  function authHeaders(currentSession, extra) {
    var cfg = config();
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + currentSession.access_token
    }, extra || {});
  }

  function showAccountView(name) {
    var settings = root();
    if (!settings) return;
    settings.hidden = false;
    document.documentElement.classList.add('gettmi-overlay-open');
    var authGate = settings.querySelector('[data-gettmi-auth-gate]');
    var profile = settings.querySelector('[data-gettmi-profile]');
    if (authGate) authGate.hidden = true;
    if (profile) profile.hidden = true;
    settings.querySelector('[data-gettmi-account-center]').hidden = true;
    settings.querySelectorAll('[data-gettmi-account-view]').forEach(function (view) {
      view.hidden = view.dataset.gettmiAccountView !== name;
    });
    if (name === 'notifications') loadNotifications();
    if (name === 'security') loadSecurity();
    if (name === 'addresses') loadAddresses();
    if (name === 'orders') loadOrders();
    if (name === 'information') loadInformation();
  }

  function closeAccountView() {
    var settings = root();
    if (!settings) return;
    settings.querySelectorAll('[data-gettmi-account-view]').forEach(function (view) {
      view.hidden = true;
    });
    if (window.matchMedia('(min-width: 1200px)').matches) {
      settings.hidden = true;
      document.documentElement.classList.remove('gettmi-overlay-open', 'gettmi-profile-open');
      return;
    }
    settings.querySelector('[data-gettmi-account-center]').hidden = false;
  }

  function setMessage(kind, message) {
    var settings = root();
    var el = settings && settings.querySelector('[data-gettmi-notifications-' + kind + ']');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setSecurityMessage(kind, message) {
    var settings = root();
    var visible = settings && settings.querySelector('[data-gettmi-account-view]:not([hidden])');
    var el = visible && visible.querySelector('[data-gettmi-security-' + kind + ']');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setFormBusy(form, busy, busyLabel) {
    var submit = form && form.querySelector('[type="submit"]');
    if (!submit) return;
    if (!submit.dataset.defaultLabel) submit.dataset.defaultLabel = submit.textContent;
    submit.disabled = busy;
    submit.textContent = busy ? busyLabel : submit.dataset.defaultLabel;
  }

  function informationView() {
    var settings = root();
    return settings && settings.querySelector('[data-gettmi-account-view="information"]');
  }

  function informationMessage(kind, message) {
    var view = informationView();
    var el = view && view.querySelector('[data-gettmi-information-' + kind + ']');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function calculateAge(dateValue) {
    var birthDate = new Date(dateValue);
    if (!dateValue || Number.isNaN(birthDate.getTime())) return null;
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) age -= 1;
    return age;
  }

  function setInformationSwitch(button, enabled) {
    var switchEl = button && button.querySelector('.gettmi-settings-switch');
    if (!switchEl) return;
    switchEl.classList.toggle('is-active', Boolean(enabled));
    switchEl.setAttribute('aria-checked', String(Boolean(enabled)));
  }

  function renderInformationProfile() {
    var view = informationView();
    if (!view) return;
    var profile = informationState.profile || {};
    ['first_name', 'last_name', 'username'].forEach(function (key) {
      var field = view.querySelector('[data-gettmi-info-field="' + key + '"]');
      if (field) field.value = profile[key] || '';
    });
    var email = view.querySelector('[data-gettmi-info-field="email"]');
    var phone = view.querySelector('[data-gettmi-info-field="phone"]');
    var emailInput = view.querySelector('[data-gettmi-info-email-form] input[name="email"]');
    var phoneInput = view.querySelector('[data-gettmi-info-phone-form] input[name="phone"]');
    if (email) email.textContent = profile.email || 'Email not added';
    if (phone) phone.textContent = profile.phone || 'Phone (optional)';
    if (emailInput) emailInput.value = profile.email || '';
    if (phoneInput) phoneInput.value = profile.phone || '';
  }

  function renderInformationConsents() {
    var view = informationView();
    if (!view) return;
    view.querySelectorAll('[data-gettmi-info-consent]').forEach(function (button) {
      var key = button.dataset.gettmiInfoConsent;
      var enabled = key === 'gettmi_personalisation'
        ? informationState.consents[key] !== false
        : Boolean(informationState.consents[key]);
      var age = calculateAge(informationState.profile.date_of_birth);
      var locked = key === 'gettmi_personalisation' && age !== null && age < 18;
      if (locked) enabled = false;
      button.disabled = locked;
      button.classList.toggle('is-locked', locked);
      setInformationSwitch(button, enabled);
      if (locked) {
        var copy = view.querySelector('[data-gettmi-info-personalisation-copy]');
        if (copy) copy.textContent = 'Not available for your account.';
      }
    });
  }

  function fetchInformationProfile() {
    var cfg = config();
    var currentSession = session();
    return window.fetch(
      cfg.url + '/rest/v1/profiles?select=email,first_name,last_name,username,phone,date_of_birth&id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&limit=1',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      informationState.profile = rows && rows[0] ? rows[0] : { email: currentSession.email || '' };
      if (!informationState.profile.email) informationState.profile.email = currentSession.email || '';
      renderInformationProfile();
    });
  }

  function fetchInformationConsents() {
    var cfg = config();
    var currentSession = session();
    return window.fetch(
      cfg.url + '/rest/v1/user_consents?select=consent_key,granted,metadata,source,updated_at&user_id=eq.' +
        encodeURIComponent(currentSession.user_id),
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      informationState.consents = {};
      informationState.consentMetadata = {};
      (rows || []).forEach(function (row) {
        informationState.consents[row.consent_key] = Boolean(row.granted);
        informationState.consentMetadata[row.consent_key] = row.metadata || {};
      });
      renderInformationConsents();
    });
  }

  function girlMathsFunction(body) {
    var cfg = config();
    var currentSession = session();
    return window.fetch(cfg.url + '/functions/v1/generate-main-character', {
      method: 'POST',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });
  }

  function loadGirlMathsConsent() {
    var cfg = config();
    var currentSession = session();
    var view = informationView();
    var button = view && view.querySelector('[data-gettmi-girlmaths-consent]');
    if (!cfg || !currentSession || !view || !button) return Promise.resolve();
    return window.fetch(
      cfg.url + '/rest/v1/app_legal_notices?select=consent_version,content&notice_key=eq.girl_maths_privacy&is_active=eq.true&limit=1',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      var notice = rows && rows[0];
      if (!notice || !notice.consent_version) throw new Error();
      informationState.girlMathsConsentVersion = notice.consent_version;
      var noticeLink = view.querySelector('[data-gettmi-girlmaths-data-notice]');
      var noticeLabel = notice.content && notice.content.card && notice.content.card.data_notice_label;
      if (noticeLink && noticeLabel) {
        noticeLink.textContent = noticeLabel;
        noticeLink.hidden = false;
      }
      return girlMathsFunction({ action: 'status' });
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (data) {
      informationState.girlMathsPhotosOn = Boolean(
        data && data.consent && data.consent.consent_version === informationState.girlMathsConsentVersion
      );
      button.disabled = false;
      setInformationSwitch(button, informationState.girlMathsPhotosOn);
    }).catch(function () {
      button.disabled = true;
      informationState.girlMathsPhotosOn = null;
    });
  }

  function loadInformation() {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id || !informationView()) return;
    informationMessage('error', '');
    informationMessage('notice', '');
    Promise.all([fetchInformationProfile(), fetchInformationConsents()]).catch(function () {
      informationMessage('error', 'Your information could not load right now.');
    });
    loadGirlMathsConsent();
  }

  function saveInformationConsent(button) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || button.disabled) return;
    var key = button.dataset.gettmiInfoConsent;
    var enabled = key === 'gettmi_personalisation'
      ? informationState.consents[key] !== false
      : Boolean(informationState.consents[key]);
    var nextEnabled = !enabled;
    button.disabled = true;
    informationMessage('error', '');
    informationMessage('notice', '');
    window.fetch(cfg.url + '/rest/v1/user_consents?on_conflict=user_id,consent_key', {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates'
      }),
      body: JSON.stringify({
        user_id: currentSession.user_id,
        consent_key: key,
        granted: nextEnabled,
        source: 'settings_info_permissions_web',
        metadata: informationState.consentMetadata[key] || {},
        updated_at: new Date().toISOString()
      })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      informationState.consents[key] = nextEnabled;
      setInformationSwitch(button, nextEnabled);
      informationMessage('notice', 'Preference saved');
    }).catch(function () {
      informationMessage('error', key === 'gettmi_email_marketing'
        ? 'Marketing preference could not be saved right now.'
        : 'Preference could not be saved right now.');
    }).finally(function () {
      button.disabled = false;
    });
  }

  function showInformationEditor(kind) {
    var view = informationView();
    if (!view) return;
    var display = view.querySelector('[data-gettmi-info-' + kind + '-display]');
    var form = view.querySelector('[data-gettmi-info-' + kind + '-form]');
    if (display) display.hidden = true;
    if (form) {
      form.hidden = false;
      var input = form.querySelector('input');
      if (input) input.focus();
    }
    informationMessage('error', '');
    informationMessage('notice', '');
  }

  function saveInformationEmail(form) {
    var cfg = config();
    var currentSession = session();
    var nextEmail = form.email.value.trim().toLowerCase();
    if (!cfg || !currentSession || !nextEmail) return;
    setFormBusy(form, true, 'Saving');
    informationMessage('error', '');
    informationMessage('notice', '');
    window.fetch(cfg.url + '/auth/v1/user', {
      method: 'PUT',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify({ email: nextEmail, email_redirect_to: callbackUrl() })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      informationMessage('notice', 'Check your new email to confirm the update.');
      form.hidden = true;
      informationView().querySelector('[data-gettmi-info-email-display]').hidden = false;
    }).catch(function () {
      informationMessage('error', 'Email update could not be started right now.');
    }).finally(function () {
      setFormBusy(form, false);
    });
  }

  function saveInformationPhone(form) {
    var profile = informationState.profile || {};
    setFormBusy(form, true, 'Saving');
    informationMessage('error', '');
    informationMessage('notice', '');
    edgeFunction({
      action: 'save_profile',
      profile: {
        firstName: profile.first_name || '',
        lastName: profile.last_name || '',
        phone: form.phone.value.trim(),
        username: profile.username || ''
      }
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return fetchInformationProfile();
    }).then(function () {
      informationMessage('notice', 'Profile details saved');
      form.hidden = true;
      informationView().querySelector('[data-gettmi-info-phone-display]').hidden = false;
    }).catch(function () {
      informationMessage('error', 'Profile details could not be saved right now.');
    }).finally(function () {
      setFormBusy(form, false);
    });
  }

  function toggleGirlMathsConsent(button) {
    if (button.disabled || informationState.girlMathsPhotosOn === null) return;
    var nextEnabled = !informationState.girlMathsPhotosOn;
    if (!nextEnabled && !window.confirm('Turn off GIRL MATHS photo permission? This deletes your saved base photo and stops your weekly look.')) {
      return;
    }
    button.disabled = true;
    informationMessage('error', '');
    informationMessage('notice', '');
    var body = nextEnabled
      ? { action: 'consent', consent_version: informationState.girlMathsConsentVersion, weekly_opt_in: true }
      : { action: 'revoke' };
    girlMathsFunction(body).then(function (response) {
      if (!response.ok) throw new Error();
      informationState.girlMathsPhotosOn = nextEnabled;
      setInformationSwitch(button, nextEnabled);
      informationMessage('notice', 'Preference saved');
    }).catch(function () {
      informationMessage('error', 'GIRL MATHS photo permission could not be saved right now.');
    }).finally(function () {
      button.disabled = false;
    });
  }

  function renderAboutContent(key) {
    var page = aboutPages[key];
    var settings = root();
    var view = settings && settings.querySelector('[data-gettmi-account-view="about-content"]');
    if (!page || !view) return;
    view.querySelector('[data-gettmi-about-content-title]').textContent = page.title;
    view.querySelector('[data-gettmi-about-hero-title]').textContent = page.heroTitle;
    view.querySelector('[data-gettmi-about-hero-subtitle]').textContent = page.heroSubtitle;

    var intro = view.querySelector('[data-gettmi-about-intro]');
    intro.replaceChildren();
    page.intro.forEach(function (paragraph) {
      intro.appendChild(element('p', '', paragraph));
    });
    var pills = element('div', 'gettmi-about-content__pills');
    page.pills.forEach(function (pill) {
      pills.appendChild(element('span', '', pill));
    });
    intro.appendChild(pills);

    var sections = view.querySelector('[data-gettmi-about-sections]');
    sections.replaceChildren();
    page.sections.forEach(function (section) {
      var block = element('section', 'gettmi-about-content__block' + (section.tone === 'alt' ? ' is-alt' : ''));
      block.appendChild(element('h3', '', section.title));
      section.paragraphs.forEach(function (paragraph) {
        block.appendChild(element('p', '', paragraph));
      });
      sections.appendChild(block);
    });

    var banner = view.querySelector('[data-gettmi-about-banner]');
    if (page.bannerImage) {
      banner.src = page.bannerImage;
      banner.hidden = false;
    } else {
      banner.removeAttribute('src');
      banner.hidden = true;
    }
    showAccountView('about-content');
  }

  function decodeJwtSessionId(token) {
    try {
      var payload = String(token || '').split('.')[1];
      if (!payload) return null;
      var normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
      while (normalized.length % 4) normalized += '=';
      return JSON.parse(window.atob(normalized)).session_id || null;
    } catch (error) {
      return null;
    }
  }

  function stableDeviceId() {
    var key = 'gettmi:device-id:v1';
    try {
      var stored = window.localStorage.getItem(key);
      if (stored) return stored;
      var created = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : 'web_' + Date.now() + '_' + Math.floor(Math.random() * 1000000000);
      window.localStorage.setItem(key, created);
      return created;
    } catch (error) {
      return 'current-browser';
    }
  }

  function browserDevice(currentSession) {
    var ua = window.navigator.userAgent || '';
    var isIphone = /iPhone/i.test(ua);
    var isIpad = /iPad/i.test(ua);
    var isAndroid = /Android/i.test(ua);
    var isMac = /Macintosh|Mac OS X/i.test(ua);
    var isWindows = /Windows/i.test(ua);
    var osName = isIphone || isIpad ? 'iOS' : isAndroid ? 'Android' : isMac ? 'macOS' : isWindows ? 'Windows' : 'Web';
    var osVersionMatch = ua.match(/(?:OS |Android |Windows NT |Mac OS X )([0-9_\.]+)/i);
    var browserName = /CriOS|Chrome/i.test(ua) ? 'Chrome' : /Safari/i.test(ua) ? 'Safari' : /Firefox/i.test(ua) ? 'Firefox' : 'Browser';
    var deviceName = isIphone ? 'iPhone' : isIpad ? 'iPad' : isAndroid ? 'Android device' : browserName + ' on ' + osName;
    return {
      appVersion: 'web',
      deviceId: stableDeviceId(),
      sessionId: decodeJwtSessionId(currentSession && currentSession.access_token),
      deviceName: deviceName,
      deviceType: isIphone || isIpad || isAndroid ? 1 : 3,
      lastSeenAt: new Date().toISOString(),
      osName: osName,
      osVersion: osVersionMatch ? osVersionMatch[1].replace(/_/g, '.') : ''
    };
  }

  function mergeTrustedDevices(devices, currentDevice) {
    var next = (Array.isArray(devices) ? devices : []).filter(function (device) {
      if (!device) return false;
      if (device.deviceId && device.deviceId === currentDevice.deviceId) return false;
      return !(device.sessionId && currentDevice.sessionId && device.sessionId === currentDevice.sessionId);
    });
    return [currentDevice].concat(next).slice(0, 8);
  }

  function saveSecuritySettings(updates) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id) return Promise.reject(new Error('Sign in again.'));
    var payload = Object.assign({
      user_id: currentSession.user_id,
      updated_at: new Date().toISOString()
    }, updates || {});
    return window.fetch(cfg.url + '/rest/v1/account_security_settings?on_conflict=user_id', {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates,return=representation'
      }),
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Security setting could not be saved.');
      return response.json();
    }).then(function (rows) {
      securityState.settings = Object.assign({}, securityState.settings, rows && rows[0] || payload);
      return securityState.settings;
    });
  }

  function securityDate(value) {
    if (!value) return 'today';
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? 'today' : date.toLocaleDateString('en-GB');
  }

  function renderSecuritySummary() {
    var settings = root();
    if (!settings) return;
    var recovery = securityState.settings.recovery_email || '';
    var recoveryMeta = settings.querySelector('[data-gettmi-security-recovery-email]');
    var recoveryInput = settings.querySelector('[data-gettmi-security-recovery-form] input[name="email"]');
    var verification = settings.querySelector('[data-gettmi-security-verification]');
    var deviceCount = settings.querySelector('[data-gettmi-security-device-count]');
    var accountStatus = settings.querySelector('[data-gettmi-security-account-status]');
    if (recoveryMeta) recoveryMeta.textContent = recovery || 'No backup email added';
    if (recoveryInput) recoveryInput.value = recovery;
    if (verification) verification.textContent = securityState.settings.verification_selfie_status === 'submitted' ? 'Submitted' : 'Not submitted';
    if (deviceCount) deviceCount.textContent = (securityState.trustedDevices.length || 1) + ' active';
    if (accountStatus) {
      accountStatus.textContent = securityState.settings.delete_account_requested_at
        ? 'Account deletion request received'
        : 'Temporarily deactivate or permanently delete your Gettmi account.';
    }
  }

  function renderTrustedDevices() {
    var settings = root();
    var list = settings && settings.querySelector('[data-gettmi-trusted-device-list]');
    if (!list) return;
    list.replaceChildren();
    var devices = securityState.trustedDevices.length
      ? securityState.trustedDevices
      : securityState.currentDevice ? [securityState.currentDevice] : [];
    if (!devices.length) {
      var fallback = element('div', 'gettmi-security__device-row');
      var fallbackCopy = element('span', '');
      fallbackCopy.append(element('strong', '', 'This device'), element('small', '', 'Signed in on this device'));
      fallback.appendChild(fallbackCopy);
      list.appendChild(fallback);
      return;
    }
    devices.forEach(function (device, index) {
      var isCurrent = securityState.currentDevice && device.deviceId === securityState.currentDevice.deviceId;
      var row = element('div', 'gettmi-security__device-row');
      var copy = element('span', '');
      copy.append(
        element('strong', '', device.deviceName || 'Device'),
        element('small', '', [device.osName, device.osVersion].filter(Boolean).join(' ') + ' · Last seen ' + securityDate(device.lastSeenAt))
      );
      var action = element('div', 'gettmi-security__device-action');
      if (isCurrent) {
        action.appendChild(element('small', '', 'This device'));
      } else {
        var button = element('button', '', 'Sign out');
        button.type = 'button';
        button.dataset.gettmiRemoveTrustedDevice = String(index);
        button.setAttribute('aria-label', 'Sign out ' + (device.deviceName || 'device'));
        action.appendChild(button);
      }
      row.append(copy, action);
      list.appendChild(row);
    });
  }

  function loadSecurity() {
    var cfg = config();
    var currentSession = session();
    var settings = root();
    if (!cfg || !currentSession || !currentSession.user_id || !settings) return;
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');

    var loginEmail = settings.querySelector('[data-gettmi-security-login-email]');
    if (loginEmail) loginEmail.textContent = currentSession.email || 'Current login email';
    var changeEmail = settings.querySelector('[data-gettmi-security-email-form] input[name="email"]');
    if (changeEmail) changeEmail.value = currentSession.email || '';

    window.fetch(
      cfg.url + '/rest/v1/account_security_settings?select=*&user_id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&limit=1',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      securityState.settings = rows && rows[0] ? rows[0] : {};
      securityState.currentDevice = browserDevice(currentSession);
      securityState.trustedDevices = mergeTrustedDevices(
        securityState.settings.trusted_devices || [],
        securityState.currentDevice
      );
      securityState.settings.trusted_devices = securityState.trustedDevices;
      renderSecuritySummary();
      renderTrustedDevices();
      saveSecuritySettings({ trusted_devices: securityState.trustedDevices }).catch(function () {
        /* The owner can still review the last saved device list. */
      });
    }).catch(function () {
      setSecurityMessage('error', 'Security settings could not load right now. Please try again.');
    });
  }

  function showSecurityPanel(panel) {
    if (panel === 'trusted-devices') renderTrustedDevices();
    if (panel === 'account-status') setAccountChoice('deactivate');
    showAccountView('security-' + panel);
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
  }

  function resetUrl() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var url = new URL(rootPath, window.location.origin);
    url.searchParams.set('gettmi_auth', 'recovery');
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    }
    return url.toString();
  }

  /* Confirmation links must land on a real storefront page; the theme has no /auth/callback route. */
  function callbackUrl() {
    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var url = new URL(rootPath, window.location.origin);
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
      url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    }
    return url.toString();
  }

  function validateNewPassword(currentPassword, nextPassword, confirmation) {
    if (nextPassword.length < 10 || !/[a-z]/.test(nextPassword) || !/[A-Z]/.test(nextPassword) || !/\d/.test(nextPassword)) {
      return 'Choose a password with at least 10 characters, including uppercase, lowercase, and a number.';
    }
    if (nextPassword !== confirmation) return 'Passwords do not match.';
    if (nextPassword === currentPassword) return 'Choose a new password that is different from your current password.';
    return '';
  }

  function changePassword(form) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.email) return;
    var currentPassword = form.current_password.value;
    var nextPassword = form.new_password.value;
    var validationError = validateNewPassword(currentPassword, nextPassword, form.confirm_password.value);
    if (validationError) {
      setSecurityMessage('error', validationError);
      return;
    }

    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    setFormBusy(form, true, 'UPDATING...');
    window.fetch(cfg.url + '/auth/v1/token?grant_type=password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: cfg.key, Authorization: 'Bearer ' + cfg.key },
      body: JSON.stringify({ email: currentSession.email, password: currentPassword })
    }).then(function (response) {
      if (!response.ok) throw new Error('reauth');
      return response.json();
    }).then(function (reauth) {
      return window.fetch(cfg.url + '/auth/v1/user', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', apikey: cfg.key, Authorization: 'Bearer ' + reauth.access_token },
        body: JSON.stringify({ password: nextPassword })
      }).then(function (response) {
        if (!response.ok) throw new Error('update');
        currentSession.access_token = reauth.access_token;
        currentSession.refresh_token = reauth.refresh_token;
        currentSession.expires_at = reauth.expires_at || (Math.floor(Date.now() / 1000) + (reauth.expires_in || 3600));
        currentSession.user_id = reauth.user && reauth.user.id || currentSession.user_id;
        writeSession(currentSession);
      });
    }).then(function () {
      form.reset();
      setSecurityMessage('notice', 'Password updated.');
    }).catch(function (error) {
      setSecurityMessage('error', error.message === 'reauth'
        ? 'Your current password could not be verified. Try again or create or reset it by email.'
        : 'Your password could not be updated. Request a reset email and try again.');
    }).finally(function () {
      setFormBusy(form, false);
    });
  }

  function requestPasswordReset() {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.email) return;
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/auth/v1/recover', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', apikey: cfg.key, Authorization: 'Bearer ' + cfg.key },
      body: JSON.stringify({ email: currentSession.email, redirect_to: resetUrl() })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      setSecurityMessage('notice', 'Check your email for a secure password link.');
    }).catch(function () {
      setSecurityMessage('error', 'Password reset email could not be sent right now.');
    });
  }

  function requestEmailChange(form) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession) return;
    var nextEmail = form.email.value.trim().toLowerCase();
    if (!nextEmail || nextEmail === String(currentSession.email || '').toLowerCase()) {
      setSecurityMessage('error', 'Enter a different valid email address.');
      return;
    }
    setFormBusy(form, true, 'SENDING...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/auth/v1/user', {
      method: 'PUT',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify({ email: nextEmail, email_redirect_to: callbackUrl() })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      setSecurityMessage('notice', 'Check your new email to confirm the change.');
    }).catch(function () {
      setSecurityMessage('error', 'Email change could not be requested.');
    }).finally(function () {
      setFormBusy(form, false);
    });
  }

  function saveRecoveryEmail(form) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession) return;
    var recoveryEmail = form.email.value.trim().toLowerCase();
    setFormBusy(form, true, 'SAVING...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/rest/v1/account_security_settings?on_conflict=user_id', {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates'
      }),
      body: JSON.stringify({
        user_id: currentSession.user_id,
        recovery_email: recoveryEmail,
        recovery_email_updated_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
    }).then(function (response) {
      if (!response.ok) throw new Error();
      var meta = root().querySelector('[data-gettmi-security-recovery-email]');
      if (meta) meta.textContent = recoveryEmail || 'No backup email added';
      setSecurityMessage('notice', 'Recovery email saved.');
    }).catch(function () {
      setSecurityMessage('error', 'Recovery email could not be saved.');
    }).finally(function () {
      setFormBusy(form, false);
    });
  }

  function setButtonBusy(button, busy, busyLabel) {
    if (!button) return;
    if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent;
    button.disabled = busy;
    button.textContent = busy ? busyLabel : button.dataset.defaultLabel;
  }

  function syncAccountAvatar(url) {
    var settings = root();
    if (!settings) return;
    var avatar = settings.querySelector('[data-gettmi-account-avatar]');
    var initial = settings.querySelector('[data-gettmi-account-initial]');
    if (avatar) {
      avatar.src = url;
      avatar.hidden = false;
    }
    if (initial) initial.hidden = true;
    document.dispatchEvent(new CustomEvent('gettmi:profile-updated', {
      detail: { profile: { profile_photo_url: url }, session: session() }
    }));
  }

  function submitVerificationPhoto(file) {
    var cfg = config();
    var currentSession = session();
    var view = root() && root().querySelector('[data-gettmi-account-view="security-verification"]');
    var button = view && view.querySelector('[data-gettmi-verification-photo]');
    if (!cfg || !currentSession || !file || !button) return;
    if (!/^image\//.test(file.type || '') || file.size > 5 * 1024 * 1024) {
      setSecurityMessage('error', 'Choose a photo under 5MB.');
      return;
    }
    var extension = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
    var path = currentSession.user_id + '/avatar.' + extension;
    var publicUrl = cfg.url + '/storage/v1/object/public/avatars/' + path + '?v=' + Date.now();
    setButtonBusy(button, true, 'SAVING...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/storage/v1/object/avatars/' + path, {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': file.type || 'image/jpeg',
        'x-upsert': 'true'
      }),
      body: file
    }).then(function (response) {
      if (!response.ok) throw new Error('upload');
      return window.fetch(
        cfg.url + '/rest/v1/profiles?id=eq.' + encodeURIComponent(currentSession.user_id),
        {
          method: 'PATCH',
          headers: authHeaders(currentSession, {
            'Content-Type': 'application/json',
            Prefer: 'return=minimal'
          }),
          body: JSON.stringify({
            profile_photo_url: publicUrl,
            updated_at: new Date().toISOString()
          })
        }
      );
    }).then(function (response) {
      if (!response.ok) throw new Error('profile');
      return saveSecuritySettings({
        verification_selfie_status: 'submitted',
        verification_selfie_updated_at: new Date().toISOString()
      });
    }).then(function () {
      securityState.settings.verification_selfie_status = 'submitted';
      renderSecuritySummary();
      syncAccountAvatar(publicUrl);
      setSecurityMessage('notice', 'Verification photo submitted.');
    }).catch(function () {
      setSecurityMessage('error', 'Verification photo could not be submitted.');
    }).finally(function () {
      setButtonBusy(button, false);
    });
  }

  function removeTrustedDevice(index, button) {
    var cfg = config();
    var currentSession = session();
    var device = securityState.trustedDevices[index];
    if (!cfg || !currentSession || !device || device.deviceId === (securityState.currentDevice && securityState.currentDevice.deviceId)) return;
    if (!device.sessionId) {
      setSecurityMessage('error', 'This session cannot be safely revoked. Sign out of all other devices instead.');
      return;
    }
    var nextDevices = securityState.trustedDevices.filter(function (_, deviceIndex) {
      return deviceIndex !== index;
    });
    setButtonBusy(button, true, 'Signing out...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/rest/v1/rpc/revoke_device_session', {
      method: 'POST',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify({ p_session_id: device.sessionId })
    }).then(function (response) {
      if (!response.ok) throw new Error('revoke');
      return saveSecuritySettings({ trusted_devices: nextDevices });
    }).then(function () {
      securityState.trustedDevices = nextDevices;
      renderTrustedDevices();
      renderSecuritySummary();
      setSecurityMessage('notice', 'Device signed out.');
    }).catch(function () {
      setSecurityMessage('error', 'That device could not be signed out right now.');
      setButtonBusy(button, false);
    });
  }

  function signOutOtherDevices(button) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !securityState.currentDevice) return;
    setButtonBusy(button, true, 'SIGNING OUT...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    window.fetch(cfg.url + '/auth/v1/logout?scope=others', {
      method: 'POST',
      headers: authHeaders(currentSession)
    }).then(function (response) {
      if (!response.ok) throw new Error();
      return saveSecuritySettings({ trusted_devices: [securityState.currentDevice] });
    }).then(function () {
      securityState.trustedDevices = [securityState.currentDevice];
      renderTrustedDevices();
      renderSecuritySummary();
      setSecurityMessage('notice', 'Signed out of all other devices.');
    }).catch(function () {
      setSecurityMessage('error', 'Could not sign out other devices right now.');
    }).finally(function () {
      setButtonBusy(button, false);
    });
  }

  function setAccountChoice(choice) {
    securityState.accountChoice = choice === 'delete' ? 'delete' : 'deactivate';
    var settings = root();
    if (!settings) return;
    settings.querySelectorAll('[data-gettmi-account-choice]').forEach(function (button) {
      var selected = button.dataset.gettmiAccountChoice === securityState.accountChoice;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  }

  function renderAccountDeletionState() {
    var view = root() && root().querySelector('[data-gettmi-account-view="security-delete-account"]');
    if (!view) return;
    var requested = Boolean(securityState.settings.delete_account_requested_at);
    var copy = view.querySelector('[data-gettmi-delete-account-copy]');
    var reason = view.querySelector('[data-gettmi-delete-reason]');
    var requestButton = view.querySelector('[data-gettmi-delete-request]');
    var confirm = view.querySelector('[data-gettmi-delete-confirm]');
    if (copy) {
      copy.textContent = requested
        ? 'We’ve received your request. We’ll complete it within 30 days and email you when deletion is finished.'
        : 'Send a deletion request to Gettmi support. We’ll complete it within 30 days and email you when deletion is finished.';
    }
    if (reason) reason.hidden = requested;
    if (requestButton) {
      requestButton.disabled = requested;
      requestButton.textContent = requested ? 'REQUEST SENT' : 'REQUEST ACCOUNT DELETION';
    }
    if (confirm) confirm.hidden = true;
  }

  function invokeSecurityFunction(name, body) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession) return Promise.reject(new Error('Sign in again.'));
    return window.fetch(cfg.url + '/functions/v1/' + name, {
      method: 'POST',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body || {})
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) throw new Error(data.error || 'The account action could not be completed.');
        return data;
      });
    });
  }

  function continueAccountChoice() {
    var panel = securityState.accountChoice === 'delete' ? 'delete-account' : 'deactivate-account';
    if (panel === 'delete-account') renderAccountDeletionState();
    showAccountView('security-' + panel);
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
  }

  function deactivateAccount(button) {
    setButtonBusy(button, true, 'DEACTIVATING...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    invokeSecurityFunction('account-deactivation', { days: 14 }).then(function (data) {
      securityState.settings = data.security_settings || securityState.settings;
      var signout = root() && root().querySelector('[data-gettmi-signout]');
      if (signout) signout.click();
    }).catch(function (error) {
      setSecurityMessage('error', error.message || 'Account could not be deactivated right now.');
      setButtonBusy(button, false);
    });
  }

  function requestAccountDeletion(button) {
    var view = root() && root().querySelector('[data-gettmi-account-view="security-delete-account"]');
    var reason = view && view.querySelector('[data-gettmi-delete-reason]');
    setButtonBusy(button, true, 'SENDING...');
    setSecurityMessage('error', '');
    setSecurityMessage('notice', '');
    invokeSecurityFunction('account-deletion-request', {
      reason: reason ? reason.value.trim() : ''
    }).then(function (data) {
      securityState.settings = data.security_settings || Object.assign({}, securityState.settings, {
        delete_account_requested_at: new Date().toISOString()
      });
      renderSecuritySummary();
      renderAccountDeletionState();
      setSecurityMessage('notice', 'Account deletion request received');
    }).catch(function (error) {
      setSecurityMessage('error', error.message || 'Deletion request could not be sent right now.');
    }).finally(function () {
      setButtonBusy(button, false);
    });
  }

  function addressView() {
    var settings = root();
    return settings && settings.querySelector('[data-gettmi-account-view="addresses"]');
  }

  function addressMessage(kind, message) {
    var view = addressView();
    var el = view && view.querySelector('[data-gettmi-address-' + kind + ']');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function addressMeta(address) {
    if (!address) return 'No saved address yet';
    var lines = [address.address1, address.address2, address.city, address.province, address.zip, address.country].filter(Boolean);
    if (!lines.length || (lines.length === 1 && lines[0] === address.country)) {
      return 'Saved in your account; add full delivery details when ready';
    }
    return lines.join(', ');
  }

  function defaultAddress() {
    return addressState.addresses.find(function (address) { return address.is_default; }) || addressState.addresses[0] || null;
  }

  function billingAddress() {
    return addressState.addresses.find(function (address) { return address.is_billing; }) || defaultAddress();
  }

  function setAddressHeader(title, heroTitle, heroCopy) {
    var view = addressView();
    if (!view) return;
    view.querySelector('[data-gettmi-address-title]').textContent = title;
    view.querySelector('[data-gettmi-address-hero-title]').textContent = heroTitle;
    view.querySelector('[data-gettmi-address-hero-copy]').textContent = heroCopy;
  }

  function showAddressMain() {
    var view = addressView();
    if (!view) return;
    addressState.role = '';
    addressState.editing = false;
    setAddressHeader('Addresses', 'Saved addresses', 'Set separate delivery and billing addresses for home, work, gifting, or event orders.');
    view.querySelector('[data-gettmi-address-list]').hidden = false;
    view.querySelector('[data-gettmi-address-role-list]').hidden = true;
    view.querySelector('[data-gettmi-address-form]').hidden = true;

    var delivery = defaultAddress();
    var billing = billingAddress();
    view.querySelector('[data-gettmi-delivery-meta]').textContent = addressMeta(delivery);
    view.querySelector('[data-gettmi-billing-meta]').textContent = addressMeta(billing);
    view.querySelector('[data-gettmi-delivery-default]').hidden = !delivery;
    view.querySelector('[data-gettmi-billing-default]').hidden = !billing;
  }

  function makeAddressRow(address, index, selected) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gettmi-settings-data__row-button';
    button.dataset.gettmiEditAddress = String(index);

    var copy = document.createElement('span');
    var title = document.createElement('strong');
    var meta = document.createElement('small');
    title.textContent = address.name || address.company || 'Address ' + (index + 1);
    meta.textContent = addressMeta(address);
    copy.appendChild(title);
    copy.appendChild(meta);

    var action = document.createElement('span');
    action.className = 'gettmi-settings-data__action';
    if (selected) {
      var pill = document.createElement('em');
      pill.textContent = 'Default';
      action.appendChild(pill);
    }
    var chevron = document.createElement('b');
    chevron.textContent = '›';
    action.appendChild(chevron);
    button.appendChild(copy);
    button.appendChild(action);
    return button;
  }

  function showAddressRole(role) {
    var view = addressView();
    if (!view) return;
    addressState.role = role;
    addressState.editing = false;
    var isBilling = role === 'billing';
    var roleTitle = isBilling ? 'Billing address' : 'Delivery address';
    setAddressHeader(roleTitle, roleTitle, 'Choose which saved address Gettmi should use for ' + (isBilling ? 'billing' : 'delivery') + '.');
    view.querySelector('[data-gettmi-address-list]').hidden = true;
    view.querySelector('[data-gettmi-address-form]').hidden = true;
    var list = view.querySelector('[data-gettmi-address-role-list]');
    list.hidden = false;
    list.replaceChildren();
    var selected = isBilling ? billingAddress() : defaultAddress();
    addressState.addresses.forEach(function (address, index) {
      list.appendChild(makeAddressRow(address, index, selected && address.shopify_address_id === selected.shopify_address_id));
    });

    var add = document.createElement('button');
    add.type = 'button';
    add.className = 'gettmi-settings-data__row-button';
    add.dataset.gettmiAddAddress = role;
    var copy = document.createElement('span');
    var title = document.createElement('strong');
    var meta = document.createElement('small');
    title.textContent = 'Add new ' + (isBilling ? 'billing' : 'delivery') + ' address';
    meta.textContent = 'Save another address option';
    copy.appendChild(title);
    copy.appendChild(meta);
    var action = document.createElement('span');
    action.className = 'gettmi-settings-data__action';
    var arrow = document.createElement('b');
    arrow.textContent = '›';
    action.appendChild(arrow);
    add.appendChild(copy);
    add.appendChild(action);
    list.appendChild(add);
  }

  function setAddressFlag(key, value) {
    var view = addressView();
    if (key === 'is_default') addressState.isDefault = Boolean(value);
    if (key === 'is_billing') addressState.isBilling = Boolean(value);
    var button = view && view.querySelector('[data-gettmi-address-flag="' + key + '"]');
    if (button) button.classList.toggle('is-active', Boolean(value));
  }

  function showAddressEditor(address) {
    var view = addressView();
    var form = view && view.querySelector('[data-gettmi-address-form]');
    if (!form) return;
    addressState.editing = true;
    addressState.activeAddress = address || null;
    setAddressHeader('Edit address', addressState.role === 'billing' ? 'Billing address' : 'Delivery address',
      'Choose which saved address Gettmi should use for ' + (addressState.role === 'billing' ? 'billing' : 'delivery') + '.');
    view.querySelector('[data-gettmi-address-list]').hidden = true;
    view.querySelector('[data-gettmi-address-role-list]').hidden = true;
    form.hidden = false;
    form.reset();
    var source = address || {};
    ['shopify_address_id', 'name', 'company', 'address1', 'address2', 'city', 'zip', 'country', 'phone'].forEach(function (key) {
      if (form.elements[key]) form.elements[key].value = source[key] || '';
    });
    form.querySelectorAll('input').forEach(function (input) { input.classList.remove('is-touched'); });
    setAddressFlag('is_default', addressState.role === 'delivery' ? true : Boolean(source.is_default));
    setAddressFlag('is_billing', addressState.role === 'billing' ? true : Boolean(source.is_billing));
    form.querySelector('[data-gettmi-address-remove]').hidden = !source.shopify_address_id;
    form.querySelector('[data-gettmi-address-remove-confirm]').hidden = true;
    addressMessage('error', '');
    addressMessage('notice', '');
  }

  function edgeFunction(body) {
    var cfg = config();
    var currentSession = session();
    return window.fetch(cfg.url + '/functions/v1/sync-shopify-customer-orders', {
      method: 'POST',
      headers: authHeaders(currentSession, { 'Content-Type': 'application/json' }),
      body: JSON.stringify(body || {})
    });
  }

  function fetchAddressRows() {
    var cfg = config();
    var currentSession = session();
    return window.fetch(
      cfg.url + '/rest/v1/shopify_customer_addresses?select=shopify_address_id,name,company,address1,address2,city,province,country,zip,phone,formatted,is_default,is_billing,updated_at&user_id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&order=is_default.desc,updated_at.desc',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    });
  }

  function loadAddresses(options) {
    var cfg = config();
    var currentSession = session();
    var view = addressView();
    if (!cfg || !currentSession || !currentSession.user_id || !view) return;
    var settings = options || {};
    var loading = view.querySelector('[data-gettmi-address-loading]');
    if (!settings.quiet && loading) loading.hidden = false;
    addressMessage('error', '');

    fetchAddressRows().then(function (rows) {
      addressState.addresses = Array.isArray(rows) ? rows : [];
      showAddressMain();
      if (!settings.skipSync) {
        edgeFunction({}).then(function (response) {
          if (!response.ok) return null;
          return fetchAddressRows();
        }).then(function (syncedRows) {
          if (!Array.isArray(syncedRows)) return;
          addressState.addresses = syncedRows;
          if (!addressState.role && !addressState.editing) showAddressMain();
        }).catch(function () {
          /* Cached owner rows remain usable when the refresh is unavailable. */
        });
      }
    }).catch(function () {
      addressMessage('error', 'Addresses could not refresh right now.');
      showAddressMain();
    }).finally(function () {
      if (loading) loading.hidden = true;
    });
  }

  function saveAddress(form) {
    var required = ['name', 'address1', 'city', 'zip', 'country'];
    var missing = required.filter(function (key) {
      var input = form.elements[key];
      input.classList.add('is-touched');
      return !input.value.trim();
    });
    if (missing.length) {
      addressMessage('error', 'Add address name, address line 1, city, postcode and country before saving.');
      return;
    }
    var submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    submit.textContent = 'SAVING';
    addressMessage('error', '');
    addressMessage('notice', '');
    var address = {};
    ['shopify_address_id', 'name', 'company', 'address1', 'address2', 'city', 'zip', 'country', 'phone'].forEach(function (key) {
      address[key] = form.elements[key].value.trim();
    });
    address.is_default = addressState.isDefault;
    address.is_billing = addressState.isBilling;

    edgeFunction({ action: 'save_address', address: address }).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (body) { throw new Error(body.error || 'Address could not be saved right now.'); });
      return fetchAddressRows();
    }).then(function (rows) {
      addressState.addresses = rows || [];
      addressState.editing = false;
      showAddressRole(addressState.role);
      addressMessage('notice', address.shopify_address_id ? 'Address updated' : 'Address added');
    }).catch(function (error) {
      addressMessage('error', error.message || 'Address could not be saved right now.');
    }).finally(function () {
      submit.disabled = false;
      submit.textContent = 'SAVE ADDRESS';
    });
  }

  function deleteAddress() {
    var form = addressView().querySelector('[data-gettmi-address-form]');
    var id = form.elements.shopify_address_id.value;
    var button = form.querySelector('[data-gettmi-address-remove-yes]');
    if (!id) return;
    button.disabled = true;
    button.textContent = 'REMOVING';
    edgeFunction({ action: 'delete_address', shopify_address_id: id }).then(function (response) {
      if (!response.ok) throw new Error();
      return fetchAddressRows();
    }).then(function (rows) {
      addressState.addresses = rows || [];
      addressState.editing = false;
      showAddressRole(addressState.role);
      addressMessage('notice', 'Address removed');
    }).catch(function () {
      addressMessage('error', 'Address could not be removed right now.');
    }).finally(function () {
      button.disabled = false;
      button.textContent = 'YES, REMOVE ADDRESS';
    });
  }

  function closeProfileView() {
    var settings = root();
    if (!settings) return;
    settings.querySelectorAll('[data-gettmi-account-view]').forEach(function (view) { view.hidden = true; });
    if (window.matchMedia('(min-width: 1200px)').matches) {
      settings.querySelector('[data-gettmi-profile]').hidden = true;
      settings.hidden = true;
      document.documentElement.classList.remove('gettmi-overlay-open', 'gettmi-profile-open');
      return;
    }
    settings.querySelector('[data-gettmi-profile]').hidden = false;
    document.documentElement.classList.add('gettmi-profile-open');
  }

  function ordersView() {
    var settings = root();
    return settings && settings.querySelector('[data-gettmi-account-view="orders"]');
  }

  function normaliseOrderStatus(value) {
    return String(value || '').replace(/_/g, ' ').replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    }).trim();
  }

  function isPastOrder(order) {
    if (!order || !order.processed_at) return false;
    var processedAt = new Date(order.processed_at).getTime();
    return !Number.isNaN(processedAt) && Date.now() - processedAt > 30 * 24 * 60 * 60 * 1000;
  }

  function isOrderInTransit(order) {
    var status = String(order && order.fulfillment_status || '').toLowerCase();
    return status.indexOf('transit') !== -1 || status.indexOf('partial') !== -1;
  }

  function formatOrderDate(value) {
    if (!value) return 'Date pending';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Date pending';
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  function formatOrderPrice(value, currency) {
    var amount = Number(value || 0);
    if (String(currency || '').toUpperCase() === 'GBP') {
      return '£' + amount.toFixed(2);
    }
    return (String(currency || '').toUpperCase() || 'GBP') + ' ' + amount.toFixed(2);
  }

  function matchesOrderQuery(order, query) {
    var clean = String(query || '').trim().toLowerCase();
    if (!clean) return true;
    var searchable = [
      order.shopify_order_name,
      order.financial_status,
      order.fulfillment_status
    ];
    (order.items || []).forEach(function (item) {
      searchable.push(item.product_title, item.vendor);
    });
    return searchable.filter(Boolean).join(' ').toLowerCase().indexOf(clean) !== -1;
  }

  function element(tag, className, textValue) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof textValue !== 'undefined') el.textContent = textValue;
    return el;
  }

  function orderEmptyCard(title, copy, loading) {
    var card = element('div', 'gettmi-orders__empty');
    if (loading) {
      var spinner = element('span', 'gettmi-settings-data__spinner');
      spinner.setAttribute('aria-hidden', 'true');
      card.appendChild(spinner);
    } else {
      card.appendChild(element('strong', '', title));
    }
    card.appendChild(element('p', '', copy));
    return card;
  }

  function orderPill(textValue) {
    return element('span', 'gettmi-orders__pill', textValue);
  }

  function orderCard(order) {
    var card = element('article', 'gettmi-orders__card');
    var header = element('div', 'gettmi-orders__card-header');
    var heading = element('span');
    heading.appendChild(element('strong', '', order.shopify_order_name || 'Order'));
    heading.appendChild(element('small', '', formatOrderDate(order.processed_at)));
    header.appendChild(heading);
    header.appendChild(element('b', '', formatOrderPrice(order.total_price, order.currency_code)));
    card.appendChild(header);

    var meta = element('div', 'gettmi-orders__pills');
    meta.appendChild(orderPill(normaliseOrderStatus(order.fulfillment_status) || 'Processing'));
    meta.appendChild(orderPill(normaliseOrderStatus(order.financial_status) || 'Payment status pending'));
    card.appendChild(meta);

    var firstItem = order.items && order.items[0];
    if (firstItem) {
      var remaining = Math.max(order.items.length - 1, 0);
      card.appendChild(element('p', 'gettmi-orders__item-copy',
        (firstItem.product_title || 'Item') + (remaining ? ' + ' + remaining + ' more' : '')));
    }

    var actions = element('div', 'gettmi-orders__actions');
    var viewButton = element('button', '', 'View order');
    viewButton.type = 'button';
    viewButton.dataset.gettmiViewOrder = String(order.shopify_order_id);
    actions.appendChild(viewButton);
    if (!isPastOrder(order)) {
      var returnButton = element('button', 'is-dark', 'Request return');
      returnButton.type = 'button';
      returnButton.dataset.gettmiRequestReturn = String(order.shopify_order_id);
      actions.appendChild(returnButton);
    }
    card.appendChild(actions);
    return card;
  }

  function updateOrdersStats() {
    var view = ordersView();
    if (!view) return;
    var active = orderState.orders.filter(function (order) { return !isPastOrder(order); });
    var past = orderState.orders.filter(isPastOrder);
    view.querySelector('[data-gettmi-orders-stat="active"]').textContent = String(active.length);
    view.querySelector('[data-gettmi-orders-stat="transit"]').textContent = String(orderState.orders.filter(isOrderInTransit).length);
    view.querySelector('[data-gettmi-orders-stat="past"]').textContent = String(past.length);
    view.querySelector('[data-gettmi-orders-active-summary]').textContent = active.length + ' Active orders';
    view.querySelector('[data-gettmi-orders-total-summary]').textContent = orderState.orders.length + ' total orders found';
    view.querySelector('[data-gettmi-orders-past-summary]').textContent = past.length + ' Past orders';
  }

  function renderOrderList(kind) {
    var view = ordersView();
    var list = view && view.querySelector('[data-gettmi-orders-list="' + kind + '"]');
    if (!list) return;
    list.replaceChildren();
    if (orderState.loading) {
      list.appendChild(orderEmptyCard('', 'Checking your latest orders.', true));
      return;
    }

    var orders = orderState.orders.slice();
    var emptyTitle = 'No active orders';
    var emptyCopy = 'When you place an order, the latest update will appear here.';
    if (kind === 'history') {
      orders = orders.filter(isPastOrder);
      if (orderState.query) orders = orders.filter(function (order) { return matchesOrderQuery(order, orderState.query); });
      emptyTitle = orderState.query ? 'No matching past orders' : 'No order history yet';
      emptyCopy = orderState.query ? 'Try another order, item, or brand.' : 'Past orders will appear here after the 30-day return window.';
    } else if (kind === 'track') {
      orders = orderState.query
        ? orders.filter(function (order) { return matchesOrderQuery(order, orderState.query); })
        : orders.filter(function (order) { return !isPastOrder(order); });
      emptyTitle = orderState.query ? 'No matching orders' : 'No active orders';
      emptyCopy = orderState.query ? 'Try another order number, item, or brand.' : 'When an order is on the move, you will see it here.';
    } else {
      orders = orders.filter(function (order) { return !isPastOrder(order); });
    }
    if (!orders.length) {
      list.appendChild(orderEmptyCard(emptyTitle, emptyCopy, false));
      return;
    }
    orders.forEach(function (order) { list.appendChild(orderCard(order)); });
  }

  function renderOrders() {
    updateOrdersStats();
    renderOrderList('orders');
    renderOrderList('history');
    renderOrderList('track');
  }

  function quotePostgrestValue(value) {
    return '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  function fetchOrderRows() {
    var cfg = config();
    var currentSession = session();
    var select = 'shopify_order_id,shopify_order_name,processed_at,financial_status,fulfillment_status,currency_code,total_price,subtotal_price,order_status_url,raw_summary,updated_at';
    return window.fetch(
      cfg.url + '/rest/v1/shopify_orders?select=' + select + '&user_id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&order=processed_at.desc.nullslast&limit=25',
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (orders) {
      var ids = (orders || []).map(function (order) { return order.shopify_order_id; }).filter(Boolean);
      if (!ids.length) return orders || [];
      var itemSelect = 'shopify_order_id,shopify_line_item_id,product_title,vendor,quantity,price,currency_code,product_path,raw_summary';
      var inFilter = 'in.(' + ids.map(quotePostgrestValue).join(',') + ')';
      return window.fetch(
        cfg.url + '/rest/v1/shopify_order_items?select=' + itemSelect + '&user_id=eq.' +
          encodeURIComponent(currentSession.user_id) + '&shopify_order_id=' + encodeURIComponent(inFilter) + '&order=created_at.desc',
        { headers: authHeaders(currentSession) }
      ).then(function (response) {
        if (!response.ok) throw new Error();
        return response.json();
      }).then(function (items) {
        var grouped = {};
        (items || []).forEach(function (item) {
          var id = String(item.shopify_order_id);
          if (!grouped[id]) grouped[id] = [];
          grouped[id].push(item);
        });
        return (orders || []).map(function (order) {
          order.items = grouped[String(order.shopify_order_id)] || [];
          return order;
        });
      });
    });
  }

  function setOrdersError(message) {
    var view = ordersView();
    var error = view && view.querySelector('[data-gettmi-orders-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function setOrdersRefreshing(refreshing) {
    var view = ordersView();
    if (!view) return;
    view.querySelectorAll('[data-gettmi-orders-refresh]').forEach(function (button) {
      if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent;
      button.disabled = refreshing;
      button.textContent = refreshing ? 'REFRESHING' : button.dataset.defaultLabel;
    });
  }

  function refreshOrders(syncFirst) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.user_id || orderState.loading) return Promise.resolve();
    orderState.loading = !orderState.loaded;
    setOrdersRefreshing(Boolean(syncFirst));
    setOrdersError('');
    renderOrders();
    var first = syncFirst ? edgeFunction({}).then(function (response) {
      if (!response.ok) throw new Error();
    }) : Promise.resolve();
    return first.then(fetchOrderRows).then(function (orders) {
      orderState.orders = Array.isArray(orders) ? orders : [];
      orderState.loaded = true;
    }).catch(function () {
      setOrdersError('Orders could not refresh right now.');
    }).finally(function () {
      orderState.loading = false;
      setOrdersRefreshing(false);
      renderOrders();
    });
  }

  function loadOrders() {
    if (orderState.loaded || orderState.loading) {
      renderOrders();
      return;
    }
    refreshOrders(false).then(function () {
      edgeFunction({}).then(function (response) {
        if (!response.ok) return null;
        return fetchOrderRows();
      }).then(function (orders) {
        if (!Array.isArray(orders)) return;
        orderState.orders = orders;
        renderOrders();
      }).catch(function () {
        /* The owner-protected mirror remains usable if background sync fails. */
      });
    });
  }

  function showOrdersTab(tabName) {
    var view = ordersView();
    if (!view) return;
    orderState.activeTab = tabName;
    view.querySelectorAll('[data-gettmi-orders-tab]').forEach(function (button) {
      var active = button.dataset.gettmiOrdersTab === tabName;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    view.querySelectorAll('[data-gettmi-orders-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.gettmiOrdersPanel !== tabName;
    });
    renderOrderList(tabName);
  }

  function timelineSteps(order) {
    var fulfillment = String(order.fulfillment_status || '').toLowerCase();
    var financial = String(order.financial_status || '').toLowerCase();
    var paid = financial.indexOf('paid') !== -1 || financial.indexOf('authorized') !== -1;
    var transit = fulfillment.indexOf('transit') !== -1 || fulfillment.indexOf('partial') !== -1 || fulfillment.indexOf('fulfilled') !== -1;
    var delivered = fulfillment.indexOf('delivered') !== -1;
    return [
      { title: 'Order placed', copy: order.processed_at ? formatOrderDate(order.processed_at) : 'Date pending', complete: Boolean(order.processed_at) },
      { title: 'Payment', copy: paid ? 'Payment confirmed' : 'Payment status pending', complete: paid },
      { title: 'Delivery', copy: delivered ? 'Delivered' : transit ? 'On the way' : 'Preparing your order', complete: transit || delivered },
      { title: 'Delivered', copy: delivered ? 'Complete' : 'We’ll update this when it arrives', complete: delivered }
    ];
  }

  function orderDetailPanel(title) {
    var panel = element('section', 'gettmi-order-detail__panel');
    panel.appendChild(element('h3', '', title));
    return panel;
  }

  function renderOrderDetail(order) {
    var settings = root();
    var detail = settings && settings.querySelector('[data-gettmi-order-detail]');
    if (!detail || !order) return;
    detail.replaceChildren();

    var items = order.items || [];
    var itemCount = items.reduce(function (total, item) { return total + Number(item.quantity || 1); }, 0);
    var hero = element('section', 'gettmi-order-detail__hero');
    var heroCopy = element('span');
    heroCopy.appendChild(element('small', '', 'GETTMI ORDER'));
    heroCopy.appendChild(element('strong', '', order.shopify_order_name || 'Order'));
    heroCopy.appendChild(element('p', '', (itemCount || items.length || 0) + ' item' +
      ((itemCount || items.length) === 1 ? '' : 's') + ' · ' + formatOrderDate(order.processed_at)));
    hero.appendChild(heroCopy);
    hero.appendChild(element('b', '', formatOrderPrice(order.total_price, order.currency_code)));
    detail.appendChild(hero);

    var progress = orderDetailPanel('Order progress');
    var timeline = element('div', 'gettmi-order-detail__timeline');
    timelineSteps(order).forEach(function (step, index, steps) {
      var row = element('div', 'gettmi-order-detail__timeline-row');
      var markerWrap = element('span', 'gettmi-order-detail__marker-wrap');
      markerWrap.appendChild(element('i', step.complete ? 'is-complete' : ''));
      if (index < steps.length - 1) markerWrap.appendChild(element('b'));
      var copy = element('span');
      copy.appendChild(element('strong', '', step.title));
      copy.appendChild(element('small', '', step.copy));
      row.appendChild(markerWrap);
      row.appendChild(copy);
      timeline.appendChild(row);
    });
    progress.appendChild(timeline);
    detail.appendChild(progress);

    var itemPanel = orderDetailPanel('Items');
    if (items.length) {
      items.forEach(function (item) {
        var row = element('div', 'gettmi-order-detail__item');
        var copy = element('span');
        copy.appendChild(element('strong', '', item.product_title || 'Item'));
        if (item.vendor) copy.appendChild(element('small', '', item.vendor));
        if (item.raw_summary && item.raw_summary.variant_title) copy.appendChild(element('small', '', item.raw_summary.variant_title));
        copy.appendChild(element('small', '', 'Qty ' + (item.quantity || 1)));
        row.appendChild(copy);
        row.appendChild(element('b', '', formatOrderPrice(item.price, item.currency_code || order.currency_code)));
        itemPanel.appendChild(row);
      });
    } else {
      itemPanel.appendChild(element('p', 'gettmi-order-detail__help', 'Items will appear here once the order has synced.'));
    }
    detail.appendChild(itemPanel);

    var summary = orderDetailPanel('Order summary');
    [['Subtotal', order.subtotal_price || order.total_price], ['Total paid', order.total_price]].forEach(function (entry) {
      var row = element('div', 'gettmi-order-detail__summary-row');
      row.appendChild(element('span', '', entry[0]));
      row.appendChild(element('strong', '', formatOrderPrice(entry[1], order.currency_code)));
      summary.appendChild(row);
    });
    var pills = element('div', 'gettmi-orders__pills');
    pills.appendChild(orderPill(normaliseOrderStatus(order.fulfillment_status) || 'Processing'));
    pills.appendChild(orderPill(normaliseOrderStatus(order.financial_status) || 'Payment status pending'));
    summary.appendChild(pills);
    detail.appendChild(summary);

    var help = orderDetailPanel('Need help?');
    help.appendChild(element('p', 'gettmi-order-detail__help', 'Returns and order questions start here, with your order details already attached.'));
    if (!isPastOrder(order)) {
      var returnButton = element('button', 'gettmi-orders__primary', 'REQUEST RETURN');
      returnButton.type = 'button';
      returnButton.dataset.gettmiRequestReturn = String(order.shopify_order_id);
      help.appendChild(returnButton);
    } else {
      help.appendChild(element('p', 'gettmi-order-detail__closed', 'This order is outside the standard return window.'));
    }
    detail.appendChild(help);
  }

  function showOrderDetail(order) {
    if (!order) return;
    orderState.activeOrder = order;
    renderOrderDetail(order);
    showAccountView('order-detail');
  }

  function returnRequestView() {
    var settings = root();
    return settings && settings.querySelector('[data-gettmi-account-view="return-request"]');
  }

  function returnLineId(item, index) {
    return String(item && item.shopify_line_item_id || (returnState.order && returnState.order.shopify_order_id || 'order') + '-' + index);
  }

  function selectedReturnItems() {
    return (returnState.order && returnState.order.items || []).filter(function (item, index) {
      return Boolean(item.shopify_line_item_id) && Boolean(returnState.selectedItemIds[returnLineId(item, index)]);
    });
  }

  function selectedReturnReason() {
    return returnReasons.find(function (reason) { return reason.code === returnState.reasonCode; }) || null;
  }

  function selectedReturnUnitCount() {
    return selectedReturnItems().reduce(function (total, item) {
      return total + (Number(item.quantity || 1) || 1);
    }, 0);
  }

  function canSubmitReturn() {
    return selectedReturnItems().length > 0 && Boolean(selectedReturnReason()) && !returnState.submitting;
  }

  function createReturnIdempotencyKey() {
    var suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Math.random().toString(36).slice(2, 12);
    return ('return_' + Date.now() + '_' + suffix).slice(0, 120);
  }

  function appendReturnInfoRow(parent, textValue) {
    var row = element('div', 'gettmi-return__info-row');
    row.appendChild(element('i'));
    row.appendChild(element('p', '', textValue));
    parent.appendChild(row);
  }

  function returnCard(kicker, title) {
    var card = element('section', 'gettmi-return__card');
    var header = element('div', 'gettmi-return__section-header');
    var copy = element('div');
    if (kicker) copy.appendChild(element('small', '', kicker));
    copy.appendChild(element('h3', '', title));
    header.appendChild(copy);
    card.appendChild(header);
    return card;
  }

  function returnReviewRow(label, value) {
    var row = element('div', 'gettmi-return__review-row');
    row.appendChild(element('span', '', label));
    row.appendChild(element('strong', '', value));
    return row;
  }

  function renderReturnConfirmation(mount) {
    var order = returnState.order || {};
    var response = returnState.submitted || {};
    var request = response.return_request || {};
    var confirmation = element('section', 'gettmi-return__confirmation');
    confirmation.appendChild(element('small', '', 'REQUEST SENT'));
    confirmation.appendChild(element('h3', '', 'Return request received'));
    confirmation.appendChild(element('p', '', 'We’ve got your return request. We’ll email a confirmation now, then send your return QR code and instructions after review.'));
    confirmation.appendChild(element('strong', '', order.shopify_order_name || 'Your order'));
    if (request.id) {
      confirmation.appendChild(element('b', '', 'Reference ' + String(request.id).slice(0, 8).toUpperCase()));
    }
    mount.appendChild(confirmation);

    var next = returnCard('', 'What happens next');
    appendReturnInfoRow(next, 'We’ll review the return details.');
    appendReturnInfoRow(next, 'We’ll email a confirmation now, then send QR code and packing instructions after review.');
    appendReturnInfoRow(next, 'Refund timing starts once the return has been accepted.');
    mount.appendChild(next);

    var back = element('button', 'gettmi-orders__primary', 'BACK TO ORDERS');
    back.type = 'button';
    back.dataset.gettmiReturnBack = '';
    mount.appendChild(back);
  }

  function renderReturnHero(mount, selectedItems, selectedReason, unitCount) {
    var order = returnState.order || {};
    var hero = element('section', 'gettmi-return__hero');
    var top = element('div', 'gettmi-return__hero-top');
    var title = element('div');
    title.appendChild(element('small', '', 'RETURN REQUEST'));
    title.appendChild(element('h3', '', order.shopify_order_name || 'Your order'));
    top.appendChild(title);
    top.appendChild(element('b', '', unitCount + ' item' + (unitCount === 1 ? '' : 's')));
    hero.appendChild(top);

    var meta = element('div', 'gettmi-return__meta');
    var ordered = element('span');
    ordered.appendChild(element('small', '', 'ORDERED'));
    ordered.appendChild(element('strong', '', formatOrderDate(order.processed_at)));
    var total = element('span');
    total.appendChild(element('small', '', 'TOTAL PAID'));
    total.appendChild(element('strong', '', formatOrderPrice(order.total_price, order.currency_code)));
    meta.append(ordered, total);
    hero.appendChild(meta);

    var steps = element('div', 'gettmi-return__steps');
    [
      { complete: selectedItems.length > 0, label: 'Items' },
      { complete: Boolean(selectedReason), label: 'Reason' },
      { complete: Boolean(returnState.note.trim()) || Boolean(selectedReason), label: 'Review' }
    ].forEach(function (step, index, allSteps) {
      var item = element('span', step.complete ? 'is-complete' : '');
      item.appendChild(element('i', '', String(index + 1)));
      item.appendChild(element('strong', '', step.label));
      if (index < allSteps.length - 1) item.appendChild(element('b'));
      steps.appendChild(item);
    });
    hero.appendChild(steps);
    mount.appendChild(hero);
  }

  function renderReturnItems(mount, selectedItems) {
    var order = returnState.order || {};
    var items = order.items || [];
    var card = returnCard('STEP 1', 'Choose item');
    var meta = element('strong', 'gettmi-return__section-meta', selectedItems.length + '/' + items.length + ' selected');
    card.querySelector('.gettmi-return__section-header').appendChild(meta);

    if (!items.length) {
      card.appendChild(element('p', 'gettmi-return__empty-copy', 'Items will appear once this order has fully synced.'));
    } else {
      items.forEach(function (item, index) {
        var lineId = returnLineId(item, index);
        var selected = Boolean(item.shopify_line_item_id) && Boolean(returnState.selectedItemIds[lineId]);
        var row = element('button', 'gettmi-return__item' + (selected ? ' is-selected' : ''));
        row.type = 'button';
        row.dataset.gettmiReturnItem = String(index);
        row.disabled = !item.shopify_line_item_id;
        row.setAttribute('aria-pressed', String(selected));

        var image = element('span', 'gettmi-return__item-image',
          String(item.vendor || item.product_title || 'G').slice(0, 1).toUpperCase());
        var copy = element('span', 'gettmi-return__item-copy');
        copy.appendChild(element('strong', '', item.product_title || 'Item'));
        if (item.vendor) copy.appendChild(element('small', '', item.vendor));
        if (item.raw_summary && item.raw_summary.variant_title) {
          copy.appendChild(element('small', '', item.raw_summary.variant_title));
        }
        var pills = element('span', 'gettmi-return__item-pills');
        pills.appendChild(element('b', '', 'Qty ' + (item.quantity || 1)));
        pills.appendChild(element('b', '', formatOrderPrice(item.price, item.currency_code || order.currency_code)));
        copy.appendChild(pills);
        var check = element('i', 'gettmi-return__check', selected ? '✓' : '');
        row.append(image, copy, check);
        card.appendChild(row);
      });
    }
    mount.appendChild(card);
  }

  function renderReturnReasons(mount, selectedReason) {
    var card = returnCard('STEP 2', 'Why are you returning it?');
    var grid = element('div', 'gettmi-return__reasons');
    returnReasons.forEach(function (reason) {
      var selected = selectedReason && selectedReason.code === reason.code;
      var button = element('button', selected ? 'is-selected' : '');
      button.type = 'button';
      button.dataset.gettmiReturnReason = reason.code;
      button.setAttribute('aria-pressed', String(Boolean(selected)));
      button.appendChild(element('small', '', reason.group));
      button.appendChild(element('strong', '', reason.label));
      button.appendChild(element('p', '', reason.hint));
      grid.appendChild(button);
    });
    card.appendChild(grid);
    mount.appendChild(card);
  }

  function renderReturnReview(mount, selectedReason, unitCount) {
    var card = returnCard('STEP 3', 'Review details');
    var note = document.createElement('textarea');
    note.className = 'gettmi-return__note';
    note.maxLength = 500;
    note.placeholder = 'Add a note if it helps us review your return.';
    note.dataset.gettmiReturnNote = '';
    note.value = returnState.note;
    card.appendChild(note);

    var review = element('div', 'gettmi-return__review');
    var returning = returnReviewRow('Returning', unitCount + ' item' + (unitCount === 1 ? '' : 's'));
    returning.querySelector('strong').dataset.gettmiReturnReview = 'items';
    var reason = returnReviewRow('Reason', selectedReason ? selectedReason.label : 'Choose one');
    reason.querySelector('strong').dataset.gettmiReturnReview = 'reason';
    var noteRow = returnReviewRow('Note', returnState.note.trim() ? 'Added' : 'Optional');
    noteRow.querySelector('strong').dataset.gettmiReturnReview = 'note';
    review.append(returning, reason, noteRow);
    card.appendChild(review);
    mount.appendChild(card);
  }

  function renderReturnRequest() {
    var view = returnRequestView();
    var mount = view && view.querySelector('[data-gettmi-return-request]');
    var title = view && view.querySelector('[data-gettmi-return-title]');
    if (!view || !mount || !returnState.order) return;
    mount.replaceChildren();
    if (returnState.submitted) {
      if (title) title.textContent = 'Return request';
      renderReturnConfirmation(mount);
      return;
    }

    if (title) title.textContent = 'Request a return';
    var selectedItems = selectedReturnItems();
    var selectedReason = selectedReturnReason();
    var unitCount = selectedReturnUnitCount();
    renderReturnHero(mount, selectedItems, selectedReason, unitCount);
    renderReturnItems(mount, selectedItems);
    renderReturnReasons(mount, selectedReason);
    renderReturnReview(mount, selectedReason, unitCount);

    var next = returnCard('AFTER SUBMITTING', 'What happens next');
    appendReturnInfoRow(next, 'We’ll review your return request.');
    appendReturnInfoRow(next, 'We’ll email a confirmation now, then send QR code and packing instructions after review.');
    appendReturnInfoRow(next, 'Refund timing depends on the payment method once the return is accepted.');
    mount.appendChild(next);

    if (returnState.error) {
      mount.appendChild(element('p', 'gettmi-orders__error gettmi-return__error', returnState.error));
    }
    var submit = element('button', 'gettmi-orders__primary', returnState.submitting ? 'SUBMITTING...' : 'SUBMIT RETURN REQUEST');
    submit.type = 'button';
    submit.dataset.gettmiReturnSubmit = '';
    submit.disabled = !canSubmitReturn();
    mount.appendChild(submit);

    var footer = element('div', 'gettmi-return__footer');
    var support = element('a', '', 'Support');
    support.href = '/pages/returns-refunds';
    footer.appendChild(support);
    mount.appendChild(footer);
  }

  function startReturnRequest(order) {
    var currentSession = session();
    if (!order || isPastOrder(order) || !currentSession || !currentSession.user_id) return;
    var selectedItemIds = {};
    var firstReturnable = (order.items || []).find(function (item) { return Boolean(item.shopify_line_item_id); });
    if (firstReturnable) selectedItemIds[String(firstReturnable.shopify_line_item_id)] = true;
    returnState.error = '';
    returnState.idempotencyKey = createReturnIdempotencyKey();
    returnState.note = '';
    returnState.order = order;
    returnState.reasonCode = '';
    returnState.selectedItemIds = selectedItemIds;
    returnState.submitted = null;
    returnState.submitting = false;
    showAccountView('return-request');
    renderReturnRequest();
    var view = returnRequestView();
    var scroll = view && view.querySelector('[data-gettmi-return-request]');
    if (scroll) scroll.scrollTop = 0;
  }

  function toggleReturnItem(index) {
    var item = returnState.order && returnState.order.items && returnState.order.items[index];
    if (!item || !item.shopify_line_item_id || returnState.submitting) return;
    var lineId = returnLineId(item, index);
    returnState.selectedItemIds[lineId] = !returnState.selectedItemIds[lineId];
    returnState.error = '';
    renderReturnRequest();
  }

  function chooseReturnReason(reasonCode) {
    if (!returnReasons.some(function (reason) { return reason.code === reasonCode; }) || returnState.submitting) return;
    returnState.reasonCode = reasonCode;
    returnState.error = '';
    renderReturnRequest();
  }

  function syncReturnNote(value) {
    returnState.note = String(value || '').slice(0, 500);
    var view = returnRequestView();
    var review = view && view.querySelector('[data-gettmi-return-review="note"]');
    if (review) review.textContent = returnState.note.trim() ? 'Added' : 'Optional';
  }

  function submitReturnRequest() {
    var cfg = config();
    var currentSession = session();
    var order = returnState.order;
    var selectedItems = selectedReturnItems();
    var reason = selectedReturnReason();
    if (!cfg || !currentSession || !currentSession.access_token || !currentSession.user_id || !order || isPastOrder(order)) {
      returnState.error = 'Sign in again before requesting a return.';
      renderReturnRequest();
      return;
    }
    if (!selectedItems.length || !reason || returnState.submitting) {
      returnState.error = 'Choose an item and reason before submitting.';
      renderReturnRequest();
      return;
    }

    returnState.error = '';
    returnState.submitting = true;
    renderReturnRequest();
    edgeFunction({
      action: 'submit_return_request',
      return_request: {
        idempotency_key: returnState.idempotencyKey,
        note: returnState.note,
        reason_code: reason.code,
        reason_label: reason.label,
        selected_items: selectedItems.map(function (item) {
          return {
            currency_code: item.currency_code || order.currency_code || null,
            product_title: item.product_title || 'Item',
            quantity: Number(item.quantity || 1) || 1,
            shopify_line_item_id: item.shopify_line_item_id,
            variant_title: item.raw_summary && item.raw_summary.variant_title || '',
            vendor: item.vendor || ''
          };
        }),
        shopify_order_id: order.shopify_order_id,
        shopify_order_name: order.shopify_order_name
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || !data.submitted || !data.return_request) {
          throw new Error(data.error || 'Return request could not be sent right now.');
        }
        return data;
      });
    }).then(function (data) {
      returnState.submitted = data;
      returnState.submitting = false;
      renderReturnRequest();
      var view = returnRequestView();
      var scroll = view && view.querySelector('[data-gettmi-return-request]');
      if (scroll) scroll.scrollTop = 0;
    }).catch(function (error) {
      returnState.error = error.message || 'Return request could not be sent right now.';
      returnState.submitting = false;
      renderReturnRequest();
    });
  }

  function applyNotificationState(values) {
    var settings = root();
    if (!settings) return;
    settings.querySelectorAll('[data-gettmi-notification-toggle]').forEach(function (button) {
      var key = button.dataset.gettmiNotificationToggle;
      var enabled = Object.prototype.hasOwnProperty.call(values, key) ? values[key] : defaults[key];
      if (key === 'security_alerts') enabled = true;
      button.classList.toggle('is-active', Boolean(enabled));
      button.setAttribute('aria-checked', String(Boolean(enabled)));
    });
  }

  function loadNotifications() {
    var cfg = config();
    var currentSession = session();
    var settings = root();
    if (!cfg || !currentSession || !currentSession.access_token || !currentSession.user_id || !settings) return;

    var loading = settings.querySelector('[data-gettmi-notifications-loading]');
    if (loading) loading.hidden = false;
    setMessage('error', '');
    setMessage('notice', '');

    var notificationFilter = appGateEnabled('notifications')
      ? '&preference_key=in.(order_updates,security_alerts)'
      : '';
    window.fetch(
      cfg.url + '/rest/v1/notification_preferences?select=preference_key,channel,enabled&user_id=eq.' +
        encodeURIComponent(currentSession.user_id) + '&channel=eq.in_app' + notificationFilter,
      { headers: authHeaders(currentSession) }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      var values = {};
      (rows || []).forEach(function (row) {
        values[row.preference_key] = Boolean(row.enabled);
      });
      applyNotificationState(values);
    }).catch(function () {
      applyNotificationState(defaults);
      setMessage('error', 'Your notification settings couldn’t load right now. Please try again shortly.');
    }).finally(function () {
      if (loading) loading.hidden = true;
    });
  }

  function saveNotification(button) {
    var cfg = config();
    var currentSession = session();
    if (!cfg || !currentSession || !currentSession.access_token || !currentSession.user_id) return;
    if (
      appGateEnabled('notifications') &&
      button.hasAttribute('data-gettmi-app-gate')
    ) {
      return;
    }

    if (button.hasAttribute('data-gettmi-preference-locked')) {
      setMessage('notice', 'Security alerts stay on to help protect your account.');
      return;
    }

    var key = button.dataset.gettmiNotificationToggle;
    var linkedKey = button.dataset.gettmiLinkedPreference;
    var enabled = button.getAttribute('aria-checked') !== 'true';
    var keys = [key].concat(linkedKey ? [linkedKey] : []);
    var now = new Date().toISOString();
    var rows = keys.map(function (preferenceKey) {
      return {
        user_id: currentSession.user_id,
        preference_key: preferenceKey,
        channel: 'in_app',
        enabled: enabled,
        metadata: {},
        paused_until: null,
        quiet_hours_end: null,
        quiet_hours_start: null,
        source: 'web_settings',
        updated_at: now
      };
    });

    setMessage('error', '');
    setMessage('notice', '');
    button.disabled = true;
    button.classList.toggle('is-active', enabled);
    button.setAttribute('aria-checked', String(enabled));

    window.fetch(cfg.url + '/rest/v1/notification_preferences?on_conflict=user_id,preference_key,channel', {
      method: 'POST',
      headers: authHeaders(currentSession, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates'
      }),
      body: JSON.stringify(rows)
    }).then(function (response) {
      if (!response.ok) throw new Error();
      setMessage('notice', 'Notification settings updated.');
    }).catch(function () {
      button.classList.toggle('is-active', !enabled);
      button.setAttribute('aria-checked', String(!enabled));
      setMessage('error', 'Could not save that notification setting. Try again.');
    }).finally(function () {
      button.disabled = false;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target.closest('[data-gettmi-open-notifications]')) {
      showAccountView('notifications');
      return;
    }
    if (target.closest('[data-gettmi-open-information]')) {
      showAccountView('information');
      return;
    }
    if (target.closest('[data-gettmi-open-about]')) {
      document.documentElement.classList.remove('gettmi-profile-open');
      showAccountView('about');
      return;
    }
    if (target.closest('[data-gettmi-open-security]')) {
      showAccountView('security');
      return;
    }
    if (target.closest('[data-gettmi-open-addresses]')) {
      document.documentElement.classList.remove('gettmi-profile-open');
      showAccountView('addresses');
      return;
    }
    if (target.closest('[data-gettmi-open-orders]')) {
      document.documentElement.classList.remove('gettmi-profile-open');
      showAccountView('orders');
      return;
    }
    var ordersTab = target.closest('[data-gettmi-orders-tab]');
    if (ordersTab) {
      showOrdersTab(ordersTab.dataset.gettmiOrdersTab);
      return;
    }
    if (target.closest('[data-gettmi-orders-refresh]')) {
      refreshOrders(true);
      return;
    }
    if (target.closest('[data-gettmi-orders-open-account]')) {
      window.location.assign('/account');
      return;
    }
    var viewOrder = target.closest('[data-gettmi-view-order]');
    if (viewOrder) {
      showOrderDetail(orderState.orders.find(function (order) {
        return String(order.shopify_order_id) === viewOrder.dataset.gettmiViewOrder;
      }));
      return;
    }
    var requestReturn = target.closest('[data-gettmi-request-return]');
    if (requestReturn) {
      startReturnRequest(orderState.orders.find(function (order) {
        return String(order.shopify_order_id) === requestReturn.dataset.gettmiRequestReturn;
      }));
      return;
    }
    var returnItem = target.closest('[data-gettmi-return-item]');
    if (returnItem) {
      toggleReturnItem(Number(returnItem.dataset.gettmiReturnItem));
      return;
    }
    var returnReason = target.closest('[data-gettmi-return-reason]');
    if (returnReason) {
      chooseReturnReason(returnReason.dataset.gettmiReturnReason);
      return;
    }
    if (target.closest('[data-gettmi-return-submit]')) {
      submitReturnRequest();
      return;
    }
    if (target.closest('[data-gettmi-return-back]')) {
      showAccountView('orders');
      return;
    }
    if (target.closest('[data-gettmi-order-detail-back]')) {
      showAccountView('orders');
      return;
    }
    if (target.closest('[data-gettmi-orders-back]')) {
      closeProfileView();
      return;
    }
    var aboutNative = target.closest('[data-gettmi-about-native]');
    if (aboutNative) {
      renderAboutContent(aboutNative.dataset.gettmiAboutNative);
      return;
    }
    if (target.closest('[data-gettmi-about-content-back]')) {
      showAccountView('about');
      return;
    }
    if (target.closest('[data-gettmi-about-back]')) {
      closeProfileView();
      return;
    }
    var infoEdit = target.closest('[data-gettmi-info-edit]');
    if (infoEdit) {
      showInformationEditor(infoEdit.dataset.gettmiInfoEdit);
      return;
    }
    var infoConsent = target.closest('[data-gettmi-info-consent]');
    if (infoConsent) {
      saveInformationConsent(infoConsent);
      return;
    }
    var girlMathsConsent = target.closest('[data-gettmi-girlmaths-consent]');
    if (girlMathsConsent) {
      toggleGirlMathsConsent(girlMathsConsent);
      return;
    }
    var securityPanel = target.closest('[data-gettmi-open-security-panel]');
    if (securityPanel) {
      showSecurityPanel(securityPanel.dataset.gettmiOpenSecurityPanel);
      return;
    }
    if (target.closest('[data-gettmi-verification-photo]')) {
      var verificationFile = root().querySelector('[data-gettmi-verification-file]');
      if (verificationFile) verificationFile.click();
      return;
    }
    var removeDevice = target.closest('[data-gettmi-remove-trusted-device]');
    if (removeDevice) {
      removeTrustedDevice(Number(removeDevice.dataset.gettmiRemoveTrustedDevice), removeDevice);
      return;
    }
    var signOutOthers = target.closest('[data-gettmi-signout-other-devices]');
    if (signOutOthers) {
      signOutOtherDevices(signOutOthers);
      return;
    }
    var accountChoice = target.closest('[data-gettmi-account-choice]');
    if (accountChoice) {
      setAccountChoice(accountChoice.dataset.gettmiAccountChoice);
      return;
    }
    if (target.closest('[data-gettmi-account-choice-continue]')) {
      continueAccountChoice();
      return;
    }
    if (target.closest('[data-gettmi-back-account-status]')) {
      showSecurityPanel('account-status');
      return;
    }
    var deactivate = target.closest('[data-gettmi-account-deactivate]');
    if (deactivate) {
      deactivateAccount(deactivate);
      return;
    }
    if (target.closest('[data-gettmi-delete-request]')) {
      var deleteConfirm = root().querySelector('[data-gettmi-delete-confirm]');
      if (deleteConfirm) deleteConfirm.hidden = false;
      return;
    }
    if (target.closest('[data-gettmi-delete-confirm-no]')) {
      var cancelConfirm = root().querySelector('[data-gettmi-delete-confirm]');
      if (cancelConfirm) cancelConfirm.hidden = true;
      return;
    }
    var confirmDelete = target.closest('[data-gettmi-delete-confirm-yes]');
    if (confirmDelete) {
      requestAccountDeletion(confirmDelete);
      return;
    }
    if (target.closest('[data-gettmi-back-security]')) {
      showAccountView('security');
      return;
    }
    if (target.closest('[data-gettmi-close-account-view]')) {
      closeAccountView();
      return;
    }
    if (target.closest('[data-gettmi-security-reset-password]')) {
      requestPasswordReset();
      return;
    }
    var roleButton = target.closest('[data-gettmi-open-address-role]');
    if (roleButton) {
      showAddressRole(roleButton.dataset.gettmiOpenAddressRole);
      return;
    }
    var editAddress = target.closest('[data-gettmi-edit-address]');
    if (editAddress) {
      showAddressEditor(addressState.addresses[Number(editAddress.dataset.gettmiEditAddress)] || null);
      return;
    }
    if (target.closest('[data-gettmi-add-address]')) {
      showAddressEditor(null);
      return;
    }
    var addressFlag = target.closest('[data-gettmi-address-flag]');
    if (addressFlag) {
      var flag = addressFlag.dataset.gettmiAddressFlag;
      setAddressFlag(flag, flag === 'is_default' ? !addressState.isDefault : !addressState.isBilling);
      return;
    }
    if (target.closest('[data-gettmi-address-cancel]')) {
      showAddressRole(addressState.role);
      return;
    }
    if (target.closest('[data-gettmi-address-remove]')) {
      target.closest('[data-gettmi-address-form]').querySelector('[data-gettmi-address-remove-confirm]').hidden = false;
      target.closest('[data-gettmi-address-remove]').hidden = true;
      return;
    }
    if (target.closest('[data-gettmi-address-remove-no]')) {
      var addressForm = target.closest('[data-gettmi-address-form]');
      addressForm.querySelector('[data-gettmi-address-remove-confirm]').hidden = true;
      addressForm.querySelector('[data-gettmi-address-remove]').hidden = false;
      return;
    }
    if (target.closest('[data-gettmi-address-remove-yes]')) {
      deleteAddress();
      return;
    }
    if (target.closest('[data-gettmi-address-back]')) {
      if (addressState.editing) showAddressRole(addressState.role);
      else if (addressState.role) showAddressMain();
      else closeProfileView();
      return;
    }
    var toggle = target.closest('[data-gettmi-notification-toggle]');
    if (toggle) saveNotification(toggle);
  });

  document.addEventListener('submit', function (event) {
    var passwordForm = event.target.closest('[data-gettmi-password-change-form]');
    var emailForm = event.target.closest('[data-gettmi-security-email-form]');
    var recoveryForm = event.target.closest('[data-gettmi-security-recovery-form]');
    var addressForm = event.target.closest('[data-gettmi-address-form]');
    var informationEmailForm = event.target.closest('[data-gettmi-info-email-form]');
    var informationPhoneForm = event.target.closest('[data-gettmi-info-phone-form]');
    if (!passwordForm && !emailForm && !recoveryForm && !addressForm && !informationEmailForm && !informationPhoneForm) return;
    event.preventDefault();
    if (passwordForm) changePassword(passwordForm);
    if (emailForm) requestEmailChange(emailForm);
    if (recoveryForm) saveRecoveryEmail(recoveryForm);
    if (addressForm) saveAddress(addressForm);
    if (informationEmailForm) saveInformationEmail(informationEmailForm);
    if (informationPhoneForm) saveInformationPhone(informationPhoneForm);
  });

  document.addEventListener('input', function (event) {
    var returnNote = event.target.closest('[data-gettmi-return-note]');
    if (returnNote) {
      syncReturnNote(returnNote.value);
      return;
    }
    var query = event.target.closest('[data-gettmi-orders-query]');
    if (!query) return;
    orderState.query = query.value;
    var peer = ordersView() && ordersView().querySelector(
      '[data-gettmi-orders-query="' + (query.dataset.gettmiOrdersQuery === 'history' ? 'track' : 'history') + '"]'
    );
    if (peer) peer.value = query.value;
    renderOrderList(query.dataset.gettmiOrdersQuery);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-gettmi-verification-file]')) return;
    var file = event.target.files && event.target.files[0];
    if (file) submitVerificationPhoto(file);
    event.target.value = '';
  });

  document.addEventListener('gettmi:signed-in', resetOwnerState);
  document.addEventListener('gettmi:signed-out', resetOwnerState);
})();
